import axios from 'axios'
import vue from "vue";
import helpers from "@/services/helpers";

export default {
  namespaced: true,
  state: {
    werehouses: null,
    historial: null,
    inventoryProduct: null,
    totalQuantity: null,
    werehouses_by_product: []
  },
  mutations: {
    SET_WAREHOUSE(state, payload){
      state.werehouses = payload.data.warehouses,
      state.historial = payload.data.historical,
      state.inventoryProduct = payload.data.product,
      state.totalQuantity = payload.data.total_quantity
    },
    SET_WAREHOUSE_CREATE(state, payload){
      console.log(payload)
    },
    SET_WAREHOUSE_BY_PRODUCT(state, payload){
      state.werehouses_by_product = payload.data
    }
  },
  getters: {
    getWarehouses: state => state.werehouses,
    getHistorial: state => state.historial,
    getInventoryProduct: state => state.inventoryProduct,
    getTotalQuantity: state => state.totalQuantity,
    getWarehouseByProduct: state => state.werehouses_by_product

  },
  actions: {
    async createInventary({ commit, dispatch }, payload) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.post('/api/inventory', payload)
        commit('SET_WAREHOUSE_CREATE', res.data)
        return res.data
      } catch (error) {

        throw error
      } finally {
        dispatch('showInventory', payload.product_id)
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async addWarehouseToInventary({ commit, dispatch }, payload) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.post('/api/add-more-warehouses', payload)
        // commit('SET_WAREHOUSE_CREATE', res.data)
        return res.data
      } catch (error) {

        throw error
      } finally {
        dispatch('showInventory', payload.product_id)
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async showInventory({ commit }, payload) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.get(`/api/inventory/product/${payload}`)
        commit('SET_WAREHOUSE', res.data)
        return res.data
      } catch (error) {

        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async getWarehouseByProduct({ commit }, payload) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        const res = await axios.get(`api/get-product-amount-per-warehouses/${payload.product}`)
        commit('SET_WAREHOUSE_BY_PRODUCT', res.data)
        return res.data.data
      } catch (error) {

        throw error
      } finally {
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
    async delete({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.delete(`/api/inventory/${id}`);
        return res.data;
      } catch (error) {
        helpers.handleError(error);
        throw error;
      } finally {
        // commit("SET_WAREHOUSES_DESTROY", id);
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async addOrSubtractInventary({ commit, dispatch }, {type, payload}) {
      commit('config/SET_OVERLAY', true, { root: true })
      try {
        if(type) {
          const res = await axios.post('/api/add-product', payload)
          vue.$toast.success(res.data.message, {
            position: "top-right"
          })
          return res.data
        }else{
          const res = await axios.post('/api/subtract-product', payload)
          vue.$toast.success(res.data.message, {
            position: "top-right"
          })
          return res.data
        }
      } catch (error) {

        throw error
      } finally {
        dispatch('getWarehouseByProduct', {
          currentPage: 1,
          perPage: 5,
          product: payload.product_id,
        })
        commit('config/SET_OVERLAY', false, { root: true })
      }
    },
  },
}
